/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { RowNode } from 'ag-grid-community';
import { GridCellRendererComponent } from '../../cell-components/grid-component.interfaces';
import { GridSelection, GridSelector } from './grid-selectable.interfaces';

@Component({
  standalone: false,
  selector: 'gh-grid-multiple-selector',
  template: `
    <mat-checkbox *ngIf="!shouldHide"
                  color="primary"
                  [disabled]="!selectable"
                  [checked]="checked"
                  (click)="onCheckboxClick($event)"
                  (change)="onChange($event)"
    ></mat-checkbox>`,
  styles: [`
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    }
    :host ::ng-deep .mat-mdc-checkbox {
      margin: 0;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridMultipleSelectorComponent implements OnInit, OnDestroy, GridCellRendererComponent, GridSelector {
  id: any;
  node: RowNode;
  private selection: GridSelection;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    this.refreshSelection = this.refreshSelection.bind(this);
  }

  get checked(): boolean {
    return this.selection.isSelected(this.id);
  }

  get shouldHide(): boolean {
    return !!(this.selection.shouldHidePinnedBottomRow && this.selection.shouldHidePinnedBottomRow(this.node));
  }

  get selectable(): boolean {
    return this.selection.isSelectable(this.node.data);
  }

  ngOnInit(): void {
    this.selection.addSelector(this.id, this);
  }

  ngOnDestroy(): void {
    this.selection.removeSelector(this.id);
    this.node.removeEventListener('dataChanged', this.refreshSelection);
  }

  agInit(params: any): void {
    this.selection = params.selection;
    this.id = params.node.id;
    this.node = params.node;

    this.node.addEventListener('dataChanged', this.refreshSelection);
  }

  refresh(params: any): boolean {
    this.changeDetectorRef.markForCheck();
    return true;
  }

  refreshSelection(): void {
    this.changeDetectorRef.markForCheck();
  }

  onChange(event: MatCheckboxChange): void {
    if (!this.selectable) {
      return;
    }
    this.selection.select(this.id, event.checked);
    this.changeDetectorRef.markForCheck();
  }

  onCheckboxClick(event: MouseEvent): void {
    event.stopPropagation();
  }
}
